import { HStack, VStack, Text } from "@chakra-ui/react";
import CheckCircleIcon from "../icons/CheckCircleIcon";
import EmptyWhiteCircle from "../icons/EmptyWhiteCircle";
import RightArrow from "../icons/RightArrow";

interface OptionItemProps {
	label: string;
	keyValue: string;
	onChange: (key: string) => void;
	description?: string;
	isSelected?: boolean;
}

const OptionItem = ({ label, description, keyValue, onChange, isSelected = false }: OptionItemProps) => {
	return (
		<VStack alignItems={"start"} maxWidth={"70%"}>
			<HStack cursor={"pointer"} onClick={() => onChange(keyValue)} spacing="2.5">
				{isSelected ? <CheckCircleIcon /> : <EmptyWhiteCircle />}
				<Text fontWeight={500} fontSize={16} my={0} color={"#333333"}>
					{label}
				</Text>
			</HStack>
			{description && (
				<HStack pl={10} alignItems={"flex-start"}>
					<span style={{ width: "20px" }}>
						<RightArrow fillColor={"#999999"} />
					</span>
					<Text fontWeight={400} fontSize={16} my={0} mt="-0.5" color={"#999999"}>
						{description}
					</Text>
				</HStack>
			)}
		</VStack>
	);
};

export default OptionItem;
